module.exports = __webpack_public_path__ + "img/gaos1.7ded215d.png";